export type EventModel = {
  id: number;
  title: string;
  discoveryId: string;
  systemId: string;
  systemSource: string;
  subSystemSource: string;
  startLocalDate: string;
  startLocalTime: string;
  dateRange: string;
  venue: VenueModel;
};

export type VenueModel = {
  title: string;
  countryCode: string;
  address: string;
  city: string;
  stateCode: string;
  postalCode: string;
};

export function getFormattedVenueAddress(venue: VenueModel): string {
  return [venue.address, venue.city, venue.stateCode, venue.postalCode]
    .filter((field) => field && field.trim())
    .join(', ');
}

export function startsBefore(event1: EventModel, event2: EventModel): boolean {
  if (event1.startLocalDate === event2.startLocalDate) {
    if (!event1.startLocalTime && !!event2.startLocalTime) {
      return false;
    }
    if (!event2.startLocalTime && !!event1.startLocalTime) {
      return true;
    }
  }

  return (
    new Date(`${event1.startLocalDate}T${event1.startLocalTime}`) <
    new Date(`${event2.startLocalDate}T${event2.startLocalTime}`)
  );
}
